import { useEffect } from 'react';
import PropTypes from 'prop-types';

const SCRIPT_ID = 'oxcim-chatplus-script';
const HIDE_STYLE_ID = 'oxcim-chatplus-hide-style';
const SITE_ID = 'cb5a8892_1';

// ログアウト後に残るウィジェットを隠す（ChatPlusが注入する要素向け）
const HIDE_CSS = `
iframe[src*="chatplus.jp"],
div[id^="cp"],
div[class*="chatplus"],
#__cp_widget,
.cp-launcher,
.cp-widget {
  display: none !important;
  visibility: hidden !important;
  pointer-events: none !important;
}
`;

const setChatPlusHidden = (hidden) => {
  let styleEl = document.getElementById(HIDE_STYLE_ID);
  if (!hidden) {
    if (styleEl) {
      styleEl.remove();
    }
    return;
  }
  if (!styleEl) {
    styleEl = document.createElement('style');
    styleEl.id = HIDE_STYLE_ID;
    document.head.appendChild(styleEl);
  }
  styleEl.textContent = HIDE_CSS;
};

const loadChatPlus = () => {
  if (document.getElementById(SCRIPT_ID)) {
    return;
  }
  // ChatPlus公式タグと同様に document へ設定（キー名は仕様上アンダースコア付き）
  const setCpProp = (key, value) => {
    document[key] = value;
  };
  setCpProp('__cp_d', 'https://app.chatplus.jp');
  setCpProp('__cp_c', SITE_ID);
  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = 'https://app.chatplus.jp/cp.js';
  document.body.appendChild(script);
};

/**
 * ログイン中のみ ChatPlus（「チャットで相談する」）を表示する。
 * 未ログイン時はスクリプトを読み込まず、ログアウト後はウィジェットを非表示にする。
 */
const ChatPlusWidget = ({ isLoggedIn }) => {
  useEffect(() => {
    if (isLoggedIn) {
      setChatPlusHidden(false);
      loadChatPlus();
      return;
    }
    setChatPlusHidden(true);
  }, [isLoggedIn]);

  return null;
};

ChatPlusWidget.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired
};

export default ChatPlusWidget;
